<template>
  <!-- pc端 -->
  <div class="footer-content">
    <!-- 输入框 -->
    <div class="footer-box">
      <div class="pander-box">
        <!-- left -->
        <div class="pander-box-left animate__backInLeft animate__animated">
          <div class="box-left-title">
            {{ $language == 'en' ? 'Contact Us' : '联系我们' }}
          </div>
          <div class="box-left-item">
            {{ $language == 'en' ? 'We wholeheartedly meet the needs of every customer and sincerely look forward to working with you!' : '尽心满足每一位顾客的需求，真诚地期待与您的合作！' }}
          </div>
          <div class="box-left-item">
            <img src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747103431678/phone.png" alt="">
            <div class="left-item-title">
              {{ $language == 'en' ? 'Telephone：' : '电话：' }}
            </div>
            <div class="left-item-value">0755-21062585</div>
          </div>
          <div class="box-left-item">
            <img src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747103507510/email.png" alt="">
            <div class="left-item-title">
              {{ $language == 'en' ? 'Email：' : '邮箱：' }}
            </div>
            <div class="left-item-value">York.shi@aliyun.com</div>
          </div>
          <div class="box-left-item">
            <img src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747103338298/mobile.png" alt="">
            <div class="left-item-title">
              {{ $language == 'en' ? 'Mobile Phone：' : '手机：' }}
            </div>
            <div class="left-item-value">15798008806/18566243638</div>
          </div>
          <div class="box-left-item">
            <img src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747041345785/QQ.png" alt="">
            <div class="left-item-title">
              QQ：
            </div>
            <div class="left-item-value">274215178</div>
          </div>
          <div class="box-left-item">
            <img src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747103584431/address.png" alt="">
            <div class="left-item-title">
              {{ $language == 'en' ? 'Address' : '地址：' }}
            </div>
            <div class="left-item-value">
              {{ $language == 'en' ? 'Room 202, Building A2, Zone B, Songbai Industrial Zone, No. 3 Villa Road, Gongming Street, Guangming District, Shenzhen.' : '深圳市光明区公明街道别墅路3号松白工业区B区A2栋202' }}
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="pander-box-right animate__backInRight animate__animated">
          <div class="box-right-title">
            {{ $language == 'en' ? 'Provide you with suitable solutions' : '为您提供合适的解决方案' }}
          </div>
          <div class="box-right-text">
            {{ $language == 'en' ? 'Fill in the requirements online, and we will reply to you as soon as we see the message!' : '在线填写需求，我们会在看见留言的第一时间给您回复！'}}
          </div>
          <!-- 需求提交 -->
          <div class="demand-content">
            <el-form ref="form" :rules="rules" :model="demandForm" label-width="0px">
              <el-form-item prop="demandContent">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 10}"
                    :placeholder="$language == 'en' ? 'Please enter your requirements' : '请输入您的需求'"
                    v-model="demandForm.demandContent">
                  </el-input>
              </el-form-item>
              <div class="demand-item">
                <el-form-item prop="name">
                  <el-input class="demand-input" v-model="demandForm.name" :placeholder="$language == 'en' ? 'Please enter your name': '请输入您的姓名'"></el-input>
                </el-form-item>
                <el-form-item prop="mobile">
                  <el-input class="demand-input" v-model="demandForm.mobile" :placeholder="$language == 'en' ? 'Please enter your phone number' : '请输入您的手机号'"></el-input>
                </el-form-item>
              </div>
              <el-form-item>
                <el-button type="primary" @click="submitDemand('form')">{{ $language == 'en' ? 'Submit' : '提交' }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情 -->
    <div class="footer-detail">
      <div class="detail-content">
        <div class="detail-title">蓝泰检测</div>
        <div class="qr-code">
          <img src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747038770240/WechatIMG10262.jpg" alt="">
          <div>
            {{ $language == 'en' ? 'QR code of official account' : '公众号二维码' }}
          </div>
        </div>
        <div class="footer-nav">
          <div class="nav-list">
            <div class="nav-item" v-for="(item, index) in navData" :key="index">
              <div @click="handleRouter(index)">
                <span>{{ $language == 'en' ? item.enLabel : item.label}}</span>
              </div>
                
            </div>
          </div>
          <!-- Copyright -->
          <div class="footer-copyright">
            
            <!-- {{ $language == 'en' ? 'Copyright@2021-2025  PRECISE TESTINGCopyright ' : 'Copyright@2021-2025  精准通检测认证版权所有' }} -->
            <a href="https://beian.miit.gov.cn/">粤ICP备2024232323号</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from '../../utils/request.js'

export default {
  name: 'footerComponent',
  data () {
    return {
      navData: [
        {
          label: '关于我们',
          enLabel: 'About Us'
        },{
          label: '蓝泰服务',
          enLabel: 'Core Services'
        },{
          label: '证书查询',
          enLabel: 'Certificate inquiry'
        },
        // {
        //   label: '新闻资讯',
        //   enLabel: 'News and Information'
        // },
        {
          label: '联系我们',
          enLabel: 'Contact us'
        }, {
          label: '加入我们',
          enLabel: 'Join us'
        }
      ],
      windowWidth: 0,
      demandForm: {
        demandContent: '',
        mobile: '',
        name: ''
      },
      rules: {
        demandContent: [
          { required: true, message: '请输入您的需求', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          { pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ]
      }
    }
  },
  watch:{ 
    windowWidth (val) {
      const _this = this
      _this.windowWidth = val
    }
  },
  mounted () {
    // 获取当前屏幕宽度
    let _this = this
    _this.windowWidth = document.documentElement.clientWidth
  },
  methods: {
    // 路由跳转
    handleRouter (value) {
      switch (value) {
        case 0:
          this.routerLink('/about') //关于我们
          break;
        case 1:
          this.routerLink('/PTC') //蓝泰服务
          break;
        case 2:
          window.location.href = 'http://www.ptc-testing.cn:8094/ReportManage/ReportQuery/Authenticity'
          break;
        // case 3:
        //   this.routerLink('/news')
        //   break;
        case 3:
          this.routerLink('/contact')
          break;
        case 4:
          this.routerLink('/JoinUs')
          break;
        default:
          console.log('error')
          break;
      }
    },
    // 跳转
    routerLink (path, query) {
      this.$router.push({path: path, query: query})
    },
    // 提交需求
    submitDemand () {
      const _this = this
      _this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(_this.demandForm)
          _this.submitRequest()
          // 提交需求
          // _this.$message.success('提交成功')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitRequest () {
      const _this = this
      const data = {
        demandContent: _this.demandForm.demandContent,
        mobile: _this.demandForm.mobile,
        name: _this.demandForm.name
      }
      http.post('v1/demand/addDemandRecord', data).then(res => {
        if (res.data.resultCode === 200) {
          _this.$message.success('提交成功')
          _this.demandForm.demandContent = ''
          _this.demandForm.mobile = ''
          _this.demandForm.name = ''
        } else {
          _this.$message.error(res.data.message)
        }
    }).catch(err => {
      console.log(err)
    })
    }
  }
}
</script>
<style scoped>
div{
  box-sizing: border-box;
}
.title{
  font-size: 48px;
  font-weight: 700;
  color: #282828;
}
.footer-content{
  width: 100%;
  min-height: 610px;
  background: #005EC9;
  overflow: hidden;
  padding-top: 60px;
}
.footer-box{
  width: 95%;
  height: 75%;
  background: #FFFFFF;
  margin: 20px auto 0;
}
.pander-box{
  width: 75vw;
  height: 100%;
  margin: 0 auto;
  padding: 45px 0;
  display: flex;
}
.pander-box > div{
  width: 50%;
}
.box-left-title{
  height: 47px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 33px;
  color: #2C2C2C;
  line-height: 47px;
  text-align: left;
  font-style: normal;
}
.box-left-item{
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 19px;
  color: #2C2C2C;
  line-height: 26px;
  text-align: left;
  font-style: normal;
  margin-top: 6px;
  margin-bottom: 36px;
  display: flex;
  align-items: center;
}
.box-left-item img{
  width: 27px;
  margin-right: 10px;
}
.left-item-title{
  font-weight: 500;
  font-size: 21px;
  color: #2C2C2C;
}
.box-right-title{
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 33px;
  color: #2C2C2C;
  text-align: left;
  font-style: normal;
}
.box-right-text{
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 19px;
  color: #2C2C2C;
  text-align: left;
  font-style: normal;
  margin: 6px 0 16px;
}
.body{
  width: 100%;
  height: 140px;
  border-radius: 6px;
  background: #f2f4f6;
  margin-bottom: 12px;
  padding: 10px 15px 0px;
  box-sizing: border-box;
  font-size: 14px;
  color: #a8a8a8;
  font-weight: lighter;
  overflow: hidden;
  resize: none;
}
.demand-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.demand-input{
  width: 350px;
}
.btn-submit{
  border: 0px;
  width: 49%;
  height: 45px;
  line-height: 45px;
  border-radius: 6px;
  background: #005EC9;
  margin-bottom: 12px;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}
.detail-content{
  width: 100%;
  height: 200px;
  padding: 40px 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.detail-title{
  font-size: 36px;
  font-weight: bold;
  color: #fff;
}
.footer-icon{
  width: 233px;
  height: 67px;
}
.qr-code{
  font-size: 14px;
  color: #fff;
}
.qr-code img{
  width: 85px;
  height: 85px;
}
.nav-list{
  width: 730px;
  display: flex;
  align-items: center;
  justify-content: space-between
}
.nav-item {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.footer-copyright,
.footer-copyright a{
  color: #fff;
  font-size: 18px;
}
.footer-copyright{
  margin-top: 50px;
}
.footer-copyright a{
  margin-left: 40px;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/Footer.vue